<div class="selection-list">
  <span class="label">Wähle die Inhalte und die Anzahl der Fragen aus</span>
  <div class="learnsets-list">
    <div *ngFor="let learnset of examLearnsets; let last = last">
      <div class="learnset" (click)="learnset.isSelected = !learnset.isSelected; selectionChanged()" [class.disabled]="!learnset.isSelected">
        <i-tabler *ngIf="!learnset.isSelected" name="square" class="square"></i-tabler>
        <i-tabler *ngIf="learnset.isSelected" name="square-check" class="square-check"></i-tabler>
        <span class="name">{{learnset.name}}</span>
        <app-number-control [min]="1" [max]="20" [(number)]="learnset.questionsCount" (numberChange)="selectionChanged()" [disabled]="!learnset.isSelected"></app-number-control>
      </div>
      <div *ngIf="!last" class="divider"></div>
    </div>
  </div>
  <span class="total-count">{{totalCount}} Fragen insgesamt</span>
</div>